import React from "react";
import { IconProps } from "../../types/types";

const ReceiptIcon: React.FC<IconProps> = ({ size = "18", color = "white" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.0475 14.775C5.6625 14.115 6.6 14.1675 7.14 14.8875L7.8975 15.9C8.505 16.7025 9.4875 16.7025 10.095 15.9L10.8525 14.8875C11.3925 14.1675 12.33 14.115 12.945 14.775C14.28 16.2 15.3675 15.7275 15.3675 13.7325V5.28C15.375 2.2575 14.67 1.5 11.835 1.5H6.165C3.33 1.5 2.625 2.2575 2.625 5.28V13.725C2.625 15.7275 3.72 16.1925 5.0475 14.775Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.07205 8.25H6.07879"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.17383 8.25H12.2988"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.07205 5.25H6.07879"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.17383 5.25H12.2988"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReceiptIcon;
